import { Button, Drawer, DrawerProps, Form, InputNumber, message } from 'antd';
import FormField from 'components/FormField';
import { Formik } from 'formik';
import { useMemo } from 'react';
import { batchUpdateUser, BatchUpdateUserBody } from 'services/api/assistant.account';
import TimeZoneField from './TimeZoneField';
import { useTimeZoneLabel } from 'utils/timeZone';
import { isNil } from 'lodash-es';

function BatchUpdateDrawer({
  userIds,
  onUpdate,
  onClose,
  ...otherProps
}: DrawerProps & {
  userIds: number[];
  onUpdate?: () => void;
}) {
  const initialValues = useMemo<BatchUpdateUserBody>(() => {
    return {
      userIds,
      timeZone: undefined,
      incomingLineLimit: undefined,
    };
  }, [userIds]);

  const { timeZoneRender, t } = useTimeZoneLabel();

  return (
    <Formik
      enableReinitialize
      initialValues={initialValues}
      onSubmit={(values, helpers) =>
        batchUpdateUser(values)
          .then(() => {
            message.success(
              isNil(values.timeZone)
                ? t('phrase.保存成功')
                : t('account_work_timeZone_update_tips', {
                    x: timeZoneRender(values.timeZone as number, false),
                  }),
            );
            onClose?.({} as any);
            helpers.resetForm();
            onUpdate?.();
          })
          .catch(() => {
            message.error(t('phrase.保存失败，请稍后再试'));
          })
      }
    >
      {({ values: { incomingLineLimit, timeZone }, isSubmitting, handleSubmit, resetForm }) => {
        return (
          <Drawer
            title={t('批量编辑')}
            width={570}
            footer={
              <>
                <Button
                  type="primary"
                  disabled={isNil(incomingLineLimit) && isNil(timeZone)}
                  loading={isSubmitting}
                  onClick={() => handleSubmit()}
                >
                  {t('保存')}
                </Button>
                <Button
                  onClick={() => {
                    onClose?.({} as any);
                    resetForm();
                  }}
                  style={{ marginLeft: '16px' }}
                >
                  {t('取消')}
                </Button>
              </>
            }
            onClose={(e) => {
              onClose?.(e);
              resetForm();
            }}
            {...otherProps}
          >
            <div className="mb-4">{t('已选x个账号', { count: userIds.length })}</div>
            <Form layout="vertical">
              <FormField<number | undefined>
                name="incomingLineLimit"
                label={t('帐号进线数')}
                description={t(
                  '客服账号最多可以接待的「待处理」会话上限，达到上限后，一般情况下将不再分配新会话',
                )}
              >
                {({ field: { value, onChange, onBlur } }) => {
                  return (
                    <InputNumber
                      style={{ width: '100%' }}
                      placeholder={t('department.请输入x', { x: '0-1000' })}
                      precision={0}
                      min={0}
                      max={1000}
                      value={value}
                      onChange={(value) => onChange(value ?? undefined)}
                      onBlur={onBlur}
                    />
                  );
                }}
              </FormField>
              <TimeZoneField required={false} />
            </Form>
          </Drawer>
        );
      }}
    </Formik>
  );
}

export default BatchUpdateDrawer;
